import {isNotNullOrUndefined} from '@wandb/weave/common/util/types';

import {useMemoizedSelector} from '../../../../state/hooks';
import {makeSectionsByNamesSelector} from '../../../../state/views/panelBankConfig/selectors';
import {useWorkspaceRefsContext} from '../../../Workspace/WorkspaceRefsContext';
import {useWorkspaceDrawerContext} from '../../WorkspaceDrawerContextProvider';
import type {AddPanelsMenuGroupProps} from '../types';

/**
 * Search the panel bank for sections with the same names as
 * the panel type groups. This is necessary for adding panels
 * at the global/workspace level.
 *
 * We can skip this for section-level add panels because the
 * selected section should always be the target in that case.
 */
export const useDefaultSectionRefs = (groups: AddPanelsMenuGroupProps[]) => {
  const {panelBankConfigRef} = useWorkspaceRefsContext();
  const {targetSectionRef} = useWorkspaceDrawerContext();
  const isGlobalAdd = targetSectionRef == null;

  const sectionNames = groups
    .map(group => group.title)
    .filter(isNotNullOrUndefined);

  return useMemoizedSelector(
    makeSectionsByNamesSelector,
    panelBankConfigRef,
    sectionNames,
    !isGlobalAdd
  );
};
